import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import InfrastructuurOverzichtForm from "./InfrastructuurOverzichtForm";
import AutoBindComponent from "../../common/AutoBindComponent";
import InfrastructuurOverzichtPageHelper from "./InfrastructuurOverzichtPageHelper";
import * as layoutActions from "../../../actions/layoutActions";
import * as sessionActions from "../../../actions/sessionActions";
import { throwException } from "../../../actions/exceptionActions";
import PropTypes from "prop-types";
import redirector from "../../../util/redirector";
import AddInfrastructurenForm from "./AddInfrastructurenForm";
import ConfirmModal from "../../common/ConfirmModal";
import { orderByPropertyName } from "../../../util/orderBy.js";
import mergeDeep from "../../../util/mergeDeep";
import AddNewInfrastructurenForm from "./AddNewInfrastructurenForm";

class InfrastructuurOverzichtPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            sportclubId: null,
            transactieId: null,
            gebruikersnaam: null,
            origineleInfrastructuren: [],
            undoButtonDisabled: true,
            showAddInfrastructurenForm: false,
            models: [],
            naamFilter: null,
            locatieFilter: null,
            sporttakFilter: null,
            aardFilter: null,
            totaalAantalZoekResultaten: -1,
            somethingChanged: false,
            zoekModels: [],
            sportclubNaam: null,
            showNewInfrastructurenForm: false,
            nieuweInfrastructuren: "",
            origineleNieuweInfrastructuren: "",
            nameFilterHasFocus: true,
            nieuweInfraHasFocus: true
        };

        this.pageHelper = new InfrastructuurOverzichtPageHelper(this, redirector);
    }

    componentDidMount = () => {
        this.props.setHasUnsavedChanges(false);
        super.componentDidMount();
        this.pageHelper.init();
    };

    getSnapshotBeforeUpdate(prevProps) {
        if (this.props.newInfrastructures != prevProps.newInfrastructures) {
            this.setState({ newInfrastructures: this.props.newInfrastructures });
        }

        return null;
    }

    handleOnChange = (event) => this.pageHelper.change(event);

    handleOnUndo = () => this.pageHelper.undo();

    handleOnSave = () => this.pageHelper.save();

    handleOnAdd = () => this.pageHelper.add();

    handleOnChangeAddInfrastructuren = (event) => this.pageHelper.changeAddInfrastructuren(event);

    handleOnCancel = () => this.pageHelper.cancel();

    handleOnContinue = () => this.pageHelper.continue();

    handleOnSearch = () => this.pageHelper.search();

    handleOnCancelUnsavedChanges = () => this.pageHelper.cancelUnsavedChanges();

    handleOnConfirmUnsavedChanges = () => this.pageHelper.confirmUnsavedChanges();

    handleOnAddNew = () => this.pageHelper.addNew();

    handleOnCancelNieuweInfrastructuren = () => this.pageHelper.cancelNieuweInfrastructuren();

    handleOnContinueNieuweInfrastructuren = () => this.pageHelper.continueNieuweInfrastructuren();

    handleOnChangeNieuweInfrastructuren = (event) => this.pageHelper.changeNieuweInfrastructuren(event);

    render() {
        const state = this.state;
        const props = this.props;
        const showAddInfrastructurenForm = state.showAddInfrastructurenForm;
        const models = state.models;
        const naamFilter = state.naamFilter;
        const locatieFilter = state.locatieFilter;
        const sporttakFilter = state.sporttakFilter;
        const aardFilter = state.aardFilter;
        const locaties = props.locaties;
        const sporttakken = props.sporttakken;
        const aarden = props.aarden;
        const hasUnsavedChanges = state.hasUnsavedChanges;
        const zoekModels = state.zoekModels;
        const disabled = props.disabled;
        const totaalAantalZoekResultaten = state.totaalAantalZoekResultaten;
        const showNewInfrastructurenForm = state.showNewInfrastructurenForm;
        const nieuweInfrastructuren = state.nieuweInfrastructuren;
        const somethingChanged = state.somethingChanged;
        const nieuweInfraHasFocus = state.nieuweInfraHasFocus;

        return (
            <div>
                {showAddInfrastructurenForm ?
                    <div>
                        <ConfirmModal
                            hookToTop={false}
                            isOpen={hasUnsavedChanges}
                            mainText="Het huidig formulier-gedeelte bevat nog niet bewaarde wijzigingen. Ben je zeker dat je wil verder gaan, en de wijzigingen verliest?"
                            title="Opgelet: niet bewaarde wijzigingen!"
                            confirmAction={this.handleOnConfirmUnsavedChanges}
                            confirmText="Ga verder"
                            cancelText="Terug"
                            cancelAction={this.handleOnCancelUnsavedChanges} />
                        <AddInfrastructurenForm
                            models={models}
                            onChange={this.handleOnChangeAddInfrastructuren}
                            onCancel={this.handleOnCancel}
                            onContinue={this.handleOnContinue}
                            naamFilter={naamFilter}
                            locatieFilter={locatieFilter}
                            sporttakFilter={sporttakFilter}
                            aardFilter={aardFilter}
                            locaties={locaties}
                            sporttakken={sporttakken}
                            aarden={aarden}
                            onSearch={this.handleOnSearch}
                            zoekModels={zoekModels}
                            totaalAantalZoekResultaten={totaalAantalZoekResultaten}
                            onAddNew={this.handleOnAddNew}
                            nieuweInfrastructuren={nieuweInfrastructuren}
                            somethingChanged={somethingChanged}
                            nameFilterHasFocus={state.nameFilterHasFocus}
                        />
                    </div>
                    :
                    showNewInfrastructurenForm ?
                        <div>
                            <ConfirmModal
                                hookToTop={false}
                                isOpen={hasUnsavedChanges}
                                mainText="Het huidig formulier-gedeelte bevat nog niet bewaarde wijzigingen. Ben je zeker dat je wil verder gaan, en de wijzigingen verliest?"
                                title="Opgelet: niet bewaarde wijzigingen!"
                                confirmAction={this.handleOnConfirmUnsavedChanges}
                                confirmText="Ga verder"
                                cancelText="Terug"
                                cancelAction={this.handleOnCancelUnsavedChanges} />
                            <AddNewInfrastructurenForm
                                onChange={this.handleOnChangeNieuweInfrastructuren}
                                onCancel={this.handleOnCancelNieuweInfrastructuren}
                                onContinue={this.handleOnContinueNieuweInfrastructuren}
                                nieuweInfrastructuren={nieuweInfrastructuren}
                                nieuweInfraHasFocus={nieuweInfraHasFocus}
                            />
                        </div>
                        :
                        <div>
                            <InfrastructuurOverzichtForm
                                models={models}
                                onChange={this.handleOnChange}
                                onUndo={this.handleOnUndo}
                                undoButtonDisabled={this.state.undoButtonDisabled}
                                onSave={this.handleOnSave}
                                onAdd={this.handleOnAdd}
                                disabled={disabled}
                                nieuweInfrastructuren={nieuweInfrastructuren}
                                onChangeNieuweInfrastructuren={this.handleOnChangeNieuweInfrastructuren}
                            />
                        </div>
                }
            </div>
        );
    }
}

InfrastructuurOverzichtPage.propTypes = {
    transactieId: PropTypes.string
};

function mapStateToProps(state, ownProps) {
    return {
        sportclubId: state.session.activeSportclubId,
        transactieId: state.session.activeTransactionId,
        gebruikersnaam: state.security.currentUser,
        federatieOndernemingsnummer: state.security.currentOrganisationInfo? state.security.currentOrganisationInfo.ondernemingsnummer: null,
        disabled: state.session.readOnly,
        locaties: state.referentie.locaties,
        sporttakken: orderByPropertyName(state.referentie.sporttakken.map((s) => mergeDeep({}, s)), "label"),
        aarden: state.referentie.aarden,
        isNew: state.session.isNew
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        loadLayout: bindActionCreators(layoutActions.loadSportOrganisatieInfrastructuurOverzichtPageLayout, dispatch),
        loadAddInfrastructurenLayout: bindActionCreators(layoutActions.loadSportOrganisatieInfrastructuurDetailPageLayout, dispatch),
        throwException: bindActionCreators(throwException, dispatch),
        setTabSettings: bindActionCreators(layoutActions.setTabSettings, dispatch),
        setActiveTransaction: bindActionCreators(sessionActions.setActiveTransactionId, dispatch),
        setHasUnsavedChanges: bindActionCreators(sessionActions.setHasUnsavedChanges, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(InfrastructuurOverzichtPage);